module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.3-create-microblog.98972f72.png";